import { useEffect, useRef } from 'react';

export function useActivated() {
    const activated = useRef(false);
    useEffect(() => {
        activated.current = true;

        return () => {
            activated.current = false;
        };
    }, []);

    return { activated };
}
